export class GenericEstimateModel {
    estimate_sequence: number
    estimate_name: string
    date_added: string
    total_charge: number
    select: boolean

    constructor(
        estimate_sequence: number,
        estimate_name: string,
        date_added: string,
        total_charge: number
    ) {
        this.estimate_sequence = estimate_sequence
        this.estimate_name = estimate_name
        this.date_added = date_added
        this.total_charge = total_charge
        this.select = false
    }
}

export class GenericEstimateDetailModel {
    dept_estimate_sequence: number
    estimate_def_sequence: number
    link_no: number
    link_type: string
    link_count: number
    link_cost: number
    code_name: string
    code_category: string
    code_no: number
    defined: boolean

    constructor(
        dept_estimate_sequence: number,
        estimate_def_sequence: number,
        link_no: number,
        link_type: string,
        link_count: number,
        link_cost: number,
        code_name: string,
        code_category: string,
        code_no: number,
        defined: boolean
    ) {
        this.dept_estimate_sequence = dept_estimate_sequence
        this.estimate_def_sequence = estimate_def_sequence
        this.link_no = link_no
        this.link_type = link_type
        this.link_count = link_count
        this.link_cost = link_cost
        this.code_name = code_name
        this.code_category = code_category
        this.code_no = code_no
        this.defined = defined
    }
}